import { Controller } from 'stimulus';

// Large centered modal for the announcement editor. Same trigger/lifecycle as the
// ticket-status editor drawer (opens when the announcement_editor turbo-frame starts
// loading the new/edit form, closes on backdrop / X / Escape, and automatically
// after a successful save), but laid out as a wide modal so the side column has room.
export default class extends Controller {
  static targets = ['overlay', 'card'];
  static values = { frame: String };

  connect() {
    const frame = document.getElementById(this.frameValue);
    this.placeholder = frame ? frame.innerHTML : '';

    this.boundOpen = this.open.bind(this);
    this.boundKeydown = this.onKeydown.bind(this);
    this.boundSubmitEnd = this.onSubmitEnd.bind(this);
    this.element.addEventListener('turbo:before-fetch-request', this.boundOpen);
    this.element.addEventListener('turbo:submit-end', this.boundSubmitEnd);
  }

  disconnect() {
    this.element.removeEventListener('turbo:before-fetch-request', this.boundOpen);
    this.element.removeEventListener('turbo:submit-end', this.boundSubmitEnd);
    document.removeEventListener('keydown', this.boundKeydown);
    document.body.classList.remove('overflow-hidden');
  }

  open() {
    this.overlayTarget.classList.remove('hidden');
    this.overlayTarget.classList.add('flex');
    document.body.classList.add('overflow-hidden');
    document.addEventListener('keydown', this.boundKeydown);
  }

  close(event) {
    if (event) event.preventDefault();
    this.overlayTarget.classList.add('hidden');
    this.overlayTarget.classList.remove('flex');
    document.body.classList.remove('overflow-hidden');
    document.removeEventListener('keydown', this.boundKeydown);

    const frame = document.getElementById(this.frameValue);
    if (frame) frame.innerHTML = this.placeholder;
  }

  // Close only when the click lands on the backdrop itself. Testing the card with
  // contains() misreads clicks whose target left the DOM before the event bubbled —
  // the Tiptap image controls drop their buttons when an alignment is committed.
  backdrop(event) {
    if (event.target === this.overlayTarget) this.close();
  }

  // A failed save returns 422 (success=false) and keeps the modal open; a successful
  // save returns turbo streams (success=true) and closes it.
  onSubmitEnd(event) {
    if (event.detail && event.detail.success) this.close();
  }

  onKeydown(event) {
    if (event.key === 'Escape') this.close();
  }
}
